import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext(null)

const ErrorProvider = function ({ children }) {
    const [errors, setErrors] = useState(null);

    return <ErrorContext.Provider value={{ errors, setErrors}}>
        { children }
    </ErrorContext.Provider>
}

export default ErrorProvider

export const useErrors = () => useContext(ErrorContext);
